var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { abbreviate, generateHSL, hashString } from '#services';
import { Tooltip, useTooltip } from '../Tooltip';
import { AVATAR_COLORS_COUNT, AVATAR_SHAPE, AVATAR_SIZE, DS_AVATAR_OFFSET, } from './Avatar.constants';
import { AvatarTestIdFactory } from './interactions';
import styles from './Avatar.module.css';
const SIZE_CLASS_MAP = {
    medium: styles.Medium,
    small: styles.Small,
};
const SHAPE_CLASS_MAP = {
    circle: styles.Circle,
    square: styles.Square,
};
export const Avatar = ({ bordered, 'data-testid': testid, fallbackAxisSideDirection, formatter = abbreviate, id, idx = 0, shape = AVATAR_SHAPE.CIRCLE, size = AVATAR_SIZE.MEDIUM, tooltip = false, tooltipClassName, value, }) => {
    _react_refresh_temp_2();
    const avatarShape = SHAPE_CLASS_MAP[shape];
    const avatarSize = SIZE_CLASS_MAP[size];
    const { isTooltipActive, tooltipProps, triggerProps } = useTooltip({
        fallbackAxisSideDirection,
    });
    const background = generateHSL({
        value: hashString(id),
        colors: AVATAR_COLORS_COUNT,
    });
    return (_jsxs(_Fragment, { children: [_jsx("span", { "data-testid": AvatarTestIdFactory.getAvatarTestId(testid), ...(tooltip && triggerProps), className: C(styles.Container, avatarShape, avatarSize, bordered ? styles.Bordered : ''), style: {
                    background,
                    transform: `translateX(${DS_AVATAR_OFFSET * idx}px)`,
                }, children: formatter(value) }), tooltip && value && isTooltipActive && (_jsx(Tooltip
            // TODO: https://lucidlink.atlassian.net/browse/LUCID-17390 - General masking approach
            , { 
                // TODO: https://lucidlink.atlassian.net/browse/LUCID-17390 - General masking approach
                className: tooltipClassName, contents: [value], tooltipProps: tooltipProps }))] }));
};
_react_refresh_temp_1 = Avatar;
$RefreshReg$(_react_refresh_temp_1, "Avatar");
_react_refresh_temp_2(Avatar, "6Z9hKiQbkXe/L4MlJ1mOoLfPqrI=", false, () => [useTooltip]);
